import { createApiRef } from '@backstage/core-plugin-api';
import { ClusterService as ClusterServiceCommon, ClusterServiceApi, RestClientApi } from '@runway/devkit-common';
import { OAuth2AAPingSSOApi } from './runwayAuthApiRefs';

export const ClusterServiceApiRef = createApiRef<ClusterServiceApi>({
  id: 'plugin.devkit.cluster-service.service',
});

class ClusterService extends ClusterServiceCommon {
  constructor(
    clusterServiceUrl: string,
    private oAuthApi: OAuth2AAPingSSOApi,
    restClient: RestClientApi,
  ) {
    super(clusterServiceUrl, '', restClient);
  }
  getToken = async () => await this.oAuthApi.getAccessToken();
}

export default ClusterService;
